import { Button, Card, CardBody, CardHeader, CardTitle, Pill } from '@/shared/components';
import type { PlatformRoleState } from './platformRole';

interface Props {
  state: PlatformRoleState;
  onGrant: () => void;
  onRevoke: () => void;
}

/**
 * Die Plattformrolle eines Kontos im Plattform-Workspace — nur für Plattform-Admins sichtbar.
 *
 * <p>Wie in der Sicherheitskarte nur Aktionen, die der Server für diesen Zustand annimmt; wo keine
 * geht, steht der Grund da. Das eigene Konto zeigt die Rolle ohne Aktion: sie entzieht ein anderer
 * Plattform-Admin, damit die Plattform nie ohne einen dasteht.</p>
 */
export function UserPlatformRoleCard({ state, onGrant, onRevoke }: Props) {
  const holder = state.kind === 'holder';
  return (
    <Card>
      <CardHeader>
        <CardTitle>Plattform-Admin</CardTitle>
      </CardHeader>
      <CardBody className="space-y-4">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <p className="text-ink-soft min-w-0 flex-1 text-xs">
            Legt Kunden-Workspaces an und wechselt als Support in sie — dort mit allen Rechten eines
            Workspace-Admins.
          </p>
          <Pill variant={holder ? 'on' : 'outline'} size="sm">
            {holder ? 'Ja' : 'Nein'}
          </Pill>
        </div>

        {state.kind === 'holder' &&
          (state.canRevoke ? (
            <Button
              variant="ghost"
              className="border-line min-h-11 w-full border"
              onClick={onRevoke}
            >
              Plattform-Admin entziehen
            </Button>
          ) : (
            <p className="text-ink-soft text-xs">
              Das ist Ihr eigenes Konto — die eigene Plattformrolle entzieht ein anderer
              Plattform-Admin.
            </p>
          ))}

        {state.kind === 'eligible' && (
          <Button variant="ghost" className="border-line min-h-11 w-full border" onClick={onGrant}>
            Zum Plattform-Admin machen
          </Button>
        )}

        {state.kind === 'ineligible' && <p className="text-ink-soft text-xs">{state.reason}</p>}
      </CardBody>
    </Card>
  );
}
